// extracted by mini-css-extract-plugin
module.exports = {"fallback":"_bd6fd08","loader":"_a9fa978","image":"_62f0416"};